
import { pickBy } from 'lodash';
import { defineComponent } from 'vue';
import globalConstants from '../shared/globalConstants';
import TrailerAssessment from '../types/TrailerAssessment';
import TrailerAssessmentType from '../types/TrailerAssessmentType';
import LastTrailerAssessmentResult from '../types/LastTrailerAssessmentResult';

const listItems: {
    [T in keyof TrailerAssessment]: string;
} = {
    brakes: 'Brakes',
    tires: 'Tires & Wheels',
    lights: 'Lights',
    damage: 'Body Damage',
    kingpinLanding: 'Kingpin & Landing Gear',
    airlinesElectrical: 'Airlines & Electrical',
    other: 'Other',
};

export default defineComponent({
    props: {
        includeCriticalDamageMessage: {
            type: Boolean,
            default: false,
        },
        trailerAssessmentResult: {
            type: LastTrailerAssessmentResult,
        },
    },
    mounted(): void {
        this.handleListLength();
    },
    updated(): void {
        this.handleListLength();
    },
    computed: {
        trailerAssessment(): TrailerAssessment {
            if (
                this.trailerAssessmentResult?.trailerAssessment instanceof
                TrailerAssessment
            )
                return this.trailerAssessmentResult.trailerAssessment;

            return new TrailerAssessment();
        },
        recordedTypes(): TrailerAssessmentType[] {
            const types = pickBy(
                this.trailerAssessment,
                (type) => type?.typeHasDamage
            );
            return Object.values(types);
        },
        hasCriticalDamage(): boolean {
            return this.recordedTypes.some(
                (assessmentType: TrailerAssessmentType) =>
                    assessmentType?.type !==
                        globalConstants.trailer.assessmentTypes.damage &&
                    assessmentType?.type !==
                        globalConstants.trailer.assessmentTypes.other
            );
        },
    },
    methods: {
        listItemTitle(type: keyof TrailerAssessment): string {
            return listItems[type] as string;
        },
        handleListLength(): void {
            // handles known deficiency in flex layout to wrap and center list items

            if (this.recordedTypes?.length > 4) {
                const container = document.getElementById('fbx-damage-list');

                if (container instanceof HTMLElement) {
                    container.classList.add('extra-wide');
                }
            }
        },
    },
});
